import type { ReactNode } from "@tanstack/react-router";
import { Navigate } from "@tanstack/react-router";
import { ROUTES } from "@/constants/routeConstants";
import { useAuthStore } from "@/store/auth";
import { useOrganizationStore } from "@/store/organization";

export const RequireOrganization = ({ children }: { children: ReactNode }) => {
  const user = useAuthStore((s) => s.user);
  const isLoading = useOrganizationStore((s) => s.isLoading);
  const organization = useOrganizationStore((s) => s.organization);

  // Wait for data to load before making any decisions
  if (isLoading) {
    return null;
  }

  if (user?.requires_terms_acceptance === true) {
    return <Navigate to={ROUTES.ACCOUNT_NUX} replace={true} />;
  }

  // Inactive organizations must resume their server-owned onboarding lifecycle.
  const isOrganizationMissing = !organization;
  const requiresOnboarding =
    organization?.account_status === "pending_approval" ||
    organization?.account_status === "provisioning";

  if (isOrganizationMissing || requiresOnboarding) {
    return <Navigate to={ROUTES.ONBOARDING} replace={true} />;
  }

  return children;
};
